import { Routes, Route } from 'react-router-dom';
import PathConstants from "./pathConstants"

import Layout from '../Layout';
import RanksPage from '../features/ranks/RanksPage';
import CompleteMatchesPage from '../features/completeMatches/CompleteMatchesPage';
import CustomClipsPage from '../features/customClips/CustomClipsPage';
import ReportGenerationPage from '../features/reportGeneration/ReportGenerationPage';
import ReportPreviewPage from '../features/reportPreview/ReportPreviewPage';
import PostMatchListPage from '../features/postMatchList/PostMatchListPage';
import ShotEvolutionReportPage from '../features/shotEvolutionReport/ShotEvolutionReportPage';
import IndexPage from '../pages/indexPage';
import DoublesMatchesPage from '../features/completeMatches/DoublesMatchesPage';

// Auth0 callback component
import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const CallbackPage = () => {
  const { isLoading, error, isAuthenticated, logout, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/');
    }
  }, [isLoading, isAuthenticated, navigate]);

  const handleLoginWithDifferentAccount = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  };

  const handleRetryLogin = () => {
    loginWithRedirect({
      redirectUri: window.location.origin + '/login/callback',
      prompt: 'select_account' // This will show account picker
    });
  };

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <h3>Processing login...</h3>
          <div style={{ marginTop: '20px' }}>
            <button
              onClick={handleLoginWithDifferentAccount}
              style={{
                padding: '10px 20px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginRight: '10px'
              }}
            >
              Login with Different Account
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div style={{ textAlign: 'center', maxWidth: '400px', padding: '20px' }}>
          <h3>Authentication Error</h3>
          <p style={{ marginBottom: '20px', color: '#dc3545' }}>{error.message}</p>
          <div>
            <button
              onClick={handleRetryLogin}
              style={{
                padding: '10px 20px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginRight: '10px',
                marginBottom: '10px'
              }}
            >
              Try Again
            </button>
            <button
              onClick={handleLoginWithDifferentAccount}
              style={{
                padding: '10px 20px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Login with Different Account
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div style={{ textAlign: 'center' }}>
        <h3>Redirecting...</h3>
        <div style={{ marginTop: '20px' }}>
          <button
            onClick={handleLoginWithDifferentAccount}
            style={{
              padding: '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Login with Different Account
          </button>
        </div>
      </div>
    </div>
  );
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={PathConstants.REPORTPREVIEW} element={<ReportPreviewPage />} />
      <Route path="/" element={<Layout />}>
        <Route path='' element={<IndexPage />} />
        <Route path={PathConstants.RANKS} element={<RanksPage />} />
        <Route path={PathConstants.SHOTSVIEW} element={<CompleteMatchesPage />} />
        <Route path={PathConstants.DOUBLES} element={<DoublesMatchesPage />} />
        <Route path={PathConstants.CUSTOMCLIPS} element={<CustomClipsPage />} />
        <Route path={PathConstants.REPORTGENERATION} element={<ReportGenerationPage />} />
        <Route path={PathConstants.POSTMATCHLIST} element={<PostMatchListPage />} />
        <Route path={PathConstants.SHOTEVOLUTIONREPORT} element={<ShotEvolutionReportPage />} />
      </Route>
      <Route path='/login/callback' element={<CallbackPage />} />
    </Routes>
  );
};

export default AppRoutes;